var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading-banner"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"skeleton"},[_c('div',{staticClass:"skeleton-wrapper"},[_c('div',{staticClass:"skeleton-wrapper-inner"},[_c('div',{staticClass:"skeleton-wrapper-body"},[_c('div',{staticClass:"skeleton-slider-banner"})])])])])])])
}]

export { render, staticRenderFns }